import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator/index';
import { Map } from 'immutable';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withStyles, CircularProgress, Grid } from '@material-ui/core';
import { FHEContainerForm, FHEItemText, FHEDivider, FormEditButton, FHETextField, FHEMiniFormEditButton } from 'data/components';
import { Toastr } from 'data/common';
import { updateProductModule, updateThreshold } from '../../../../../data/Products/actions';

class Relay extends PureComponent {
    static propTypes = {
        theme: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        planningMode: PropTypes.string,
        productType: PropTypes.string,
        threshold: PropTypes.number,
        code: PropTypes.string,
        middleware: PropTypes.string,
        lineType: PropTypes.string,
        value: PropTypes.string,
        label: PropTypes.string,
        updateProductModule: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        expanded: PropTypes.string,
        productModulekey: PropTypes.string.isRequired,
        profile: PropTypes.object.isRequired,
        type: PropTypes.string,
        updateThreshold: PropTypes.func.isRequired,
        fheCenter_mac: PropTypes.string
    };

    static defaultProps = {
        expanded: null,
        planningMode: null,
        productType: null,
        threshold: null,
        middleware: null,
        code: null,
        lineType: null,
        value: null,
        label: null,
        type: null,
        fheCenter_mac: null
    };

    constructor(props) {
        super(props);
        this.state = {
            formDisabled: true,
            formThresholdDisabled: true,
            textInput_error: {},
            sendLoading: false,
            sendLoadingThreshold: false,
            form: {
                label: null
            },
            threshold: null,
            loading: false,
            loadingThreshold: true
        };
    }

    static getDerivedStateFromProps(props, state) {
        const { formDisabled, formThresholdDisabled } = state;
        const { label, threshold } = props;

        if (formDisabled && label !== state.form.label) {
            return {
                form: {
                    label
                },
                loading: false
            };
        }
        if (formThresholdDisabled && threshold !== state.threshold) {
            return {
                threshold,
                loadingThreshold: false
            };
        }

        return null;
    }

    handleEdit = () => {
        const { formDisabled } = this.state;
        if (formDisabled === true) {
            this.setState({
                formDisabled: false,
                formThresholdDisabled: true
            });
        } else {
            this.loadInputs();
            this.setState({
                formDisabled: true,
                textInput_error: {}
            });
        }
    };

    handleEditThreshold = () => {
        const { formThresholdDisabled } = this.state;
        if (formThresholdDisabled === true) {
            this.setState({
                formDisabled: true,
                formThresholdDisabled: false
            });
        } else {
            this.loadInputs();
            this.setState({
                formThresholdDisabled: true,
                textInput_error: {}
            });
        }
    };

    handleFormError = (fields, message) => {
        let res = {};
        Object.keys(fields).map(field => {
            fields[field].forEach(error => {
                if (res[field] === undefined) res[field] = [];

                res[field].push(
                    <p key={error} className="mb-1">
                        {Translator.translate(`general.fields.error.${error}`)}
                    </p>
                );
            });
        });

        this.setState({
            textInput_error: res
        });

        return Toastr.error(message);
    };

    handleChangeWithVerification = event => {
        const { form, textInput_error } = this.state;
        let targetValue = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

        const fieldLengthRules = {
            label: 255
        };

        let newTextInput_error = this.removeKey(textInput_error, event.target.name);

        let maxLength = fieldLengthRules[event.target.name];
        if (maxLength && targetValue.length > maxLength) targetValue = form[event.target.name];
        if (targetValue === '') targetValue = null;

        this.setState({
            form: { ...form, [event.target.name]: targetValue },
            textInput_error: newTextInput_error
        });
    };

    handleChange = event => {
        const { form } = this.state;
        if (event.target.name === 'threshold') {
            this.setState({
                [event.target.name]: event.target.value
            });
        } else {
            this.setState({
                form: { ...form, [event.target.name]: event.target.value }
            });
        }
    };

    isEmpty = value => {
        return value === null || /^\s*$/.test(value);
    };

    loadInputs = () => {
        const { label, threshold } = this.props;
        this.setState({
            loading: false,
            loadingThreshold: false,
            form: {
                label: label
            },
            threshold: threshold
        });
    };

    removeKey = (myObj, deleteKey) => {
        return Object.assign(
            {},
            ...Object.entries(myObj)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v }))
        );
    };

    formatForm = () => {
        const { form } = this.state;
        let newForm = form;
        Object.keys(newForm).forEach(key => {
            if (newForm[key] === '') {
                newForm[key] = null;
            }
        });
        this.setState({
            form: newForm
        });
    };

    confirmEdit = () => {
        const { form } = this.state;
        const { updateProductModule, match, code, type, lineType } = this.props;

        this.formatForm();

        if (this.validateForm(form)) {
            this.setState({
                sendLoading: true,
                formDisabled: true
            });

            return updateProductModule(match.params.homeId, match.params.productIdentifier, match.params.productType, code, form, type, lineType)
                .then(() => {
                    Toastr.success(Translator.translate('generic.products.actions.editProductModuleSuccess'));
                    this.loadInputs();
                    this.setState({
                        formDisabled: true,
                        sendLoading: false
                    });
                })
                .catch(error => {
                    this.setState({
                        sendLoading: false,
                        formDisabled: false
                    });
                    Toastr.error(Translator.translate('generic.products.actions.editProductModuleError'));
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(error.validation.errors, Translator.translate('generic.products.actions.editProductModuleError'));
                    }
                });
        }
    };

    confirmEditThreshold = () => {
        const { threshold } = this.state;
        const { updateThreshold, match, code, type, fheCenter_mac, middleware } = this.props;

        if (this.validateThreshold(threshold)) {
            this.setState({
                sendLoadingThreshold: true,
                formThresholdDisabled: true
            });
            return updateThreshold(middleware, fheCenter_mac, match.params.productIdentifier, type, code, parseInt(threshold))
                .then(() => {
                    Toastr.success(Translator.translate('generic.products.actions.editProductModuleThresholdSuccess'));
                    this.loadInputs();
                    this.setState({
                        formThresholdDisabled: true,
                        sendLoadingThreshold: false
                    });
                })
                .catch(error => {
                    this.setState({
                        sendLoadingThreshold: false,
                        formThresholdDisabled: false
                    });
                    Toastr.error(
                        Translator.translateWithFallback(`socket.error.${error.message ? error.message : error}`, 'socket.error.defaultError'),
                        Translator.translate('generic.products.actions.editProductModuleError')
                    );
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(error.validation.errors, Translator.translate('generic.products.actions.editProductModuleError'));
                    }
                });
        }
    };

    validateForm = () => {
        const errors = {};

        this.setState({
            textInput_error: errors
        });

        return Object.keys(errors).length <= 0;
    };

    validateThreshold = threshold => {
        const errors = {};

        if (isNaN(parseInt(threshold))) {
            errors['threshold'] = Translator.translate('general.fields.error.any.notANumber');
        }
        if (typeof parseInt(threshold) !== 'number') {
            errors['threshold'] = Translator.translate('general.fields.error.any.notANumber');
        }

        this.setState({
            textInput_error: errors
        });

        return Object.keys(errors).length <= 0;
    };

    render() {
        const { classes, planningMode, lineType, value, theme, expanded, productModulekey, profile, type } = this.props;
        const {
            formDisabled,
            formThresholdDisabled,
            textInput_error,
            sendLoading,
            sendLoadingThreshold,
            form,
            loading,
            loadingThreshold,
            threshold
        } = this.state;
        const userRightUpdate =
            profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes(`productModules_${type}_${lineType}_update`);
        return (
            <div className={classes.container}>
                {expanded === productModulekey && userRightUpdate && (
                    <FormEditButton
                        useSecondaryPosition
                        formDisabled={formDisabled}
                        handleEdit={this.handleEdit}
                        confirmEdit={this.confirmEdit}
                        sendLoading={sendLoading}
                    />
                )}

                <FHEContainerForm withoutPadding>
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                loading={loading}
                                disabled={formDisabled}
                                id="label"
                                value={!form.label || form.label === null ? '' : form.label}
                                error={textInput_error.label}
                                label={Translator.translate('general.table.column.label')}
                                name="label"
                                onChange={this.handleChangeWithVerification}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText itemTitle={Translator.translate('general.table.column.value')} itemContent={value} />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText
                                itemTitle={Translator.translate('general.table.column.planningMode')}
                                itemContent={Translator.translate(`general.productModules.${planningMode}`)}
                            />
                        </Grid>
                        <FHEDivider color={theme.palette.colors.grey100} />
                        <Grid container item sm={12} md={6} lg={4} className={classes.containerMiniForm}>
                            {!loadingThreshold ? (
                                <FHEMiniFormEditButton
                                    handleEdit={this.handleEditThreshold}
                                    confirmEdit={this.confirmEditThreshold}
                                    sendLoading={sendLoadingThreshold}
                                    formDisabled={formThresholdDisabled}
                                    hasRightToEdit={userRightUpdate}
                                >
                                    <FHETextField
                                        disabled={formThresholdDisabled}
                                        id="label"
                                        value={threshold === null ? '' : threshold}
                                        error={textInput_error.threshold}
                                        label={Translator.translate('general.table.column.threshold')}
                                        name="threshold"
                                        onChange={this.handleChange}
                                        type="number"
                                    />
                                </FHEMiniFormEditButton>
                            ) : (
                                <div className={classes.loadingContainer}>
                                    <CircularProgress />
                                </div>
                            )}
                        </Grid>
                    </Grid>
                </FHEContainerForm>
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    const productKey = props.productKey;
    const productModulekey = props.productModulekey;
    const product = state.environments.fhe.data.Products.getIn(['list', productKey], new Map());

    const productModule = state.environments.fhe.data.Products.getIn(['list', productKey, 'productModules', productModulekey], new Map());
    let fheCenter_mac = null;
    let middleware = null;
    state.environments.fhe.data.Boxes.get('list').map((box, macAddress) => {
        if (box.get('homeId') === productModule.get('homeId')) {
            fheCenter_mac = macAddress;
            middleware = box.get('middleware');
        }
    });
    return {
        profile: state.data.user,
        type: product.get('type'),
        productType: productModule.get('productType'),
        threshold: productModule.get('threshold'),
        code: productModule.get('code'),
        lineType: productModule.get('lineType'),
        value: productModule.get('value'),
        label: productModule.get('label'),
        planningMode: productModule.get('planningMode'),
        productIdentifier: productModule.get('productIdentifier'),
        productModulekey: productModulekey,
        fheCenter_mac,
        middleware
    };
}

const styles = () => ({
    container: {
        width: '100%'
    },
    containerMiniForm: {
        position: 'relative'
    }
});
export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ updateProductModule, updateThreshold }, dispatch)
    )(withStyles(styles, { withTheme: true })(Relay))
);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Products/components/ProductModule/DriveElec/Relay.js